import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "~/components/ui/dialog";
import { Button } from "~/components/ui/button";
import { Maximize2 } from "lucide-react";

interface ExpandableChartProps {
  title?: string;
  children: React.ReactElement<{ className?: string }>;
}

export function ExpandableChart({ title, children }: ExpandableChartProps) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <Dialog open={isExpanded} onOpenChange={setIsExpanded}>
      <div className="relative">
        {children}
        <DialogTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="absolute top-1 right-1 z-10"
          >
            <Maximize2 className="h-2 w-2" />
          </Button>
        </DialogTrigger>
      </div>
      <DialogContent className="max-w-7xl flex flex-col">
        <DialogHeader>
          {title && <DialogTitle>{title}</DialogTitle>}
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}
